import '../applied_filter_view.js.coffee';# Added by Script 
Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.AppliedPostTypeView extends Monitoring.Views.SocialContents.Filters.AppliedFilterView
  name: 'post_type'
  humanize: true

  removeFilter: (value) ->
    @searchQuery.removePostType(value)
